import React from 'react';

import BaseButton from './base/BaseButton';
import TextIcon from './features/TextIcon';
import Icon from './features/Icon';

// Button B v2

const Button = ({ children, ...rest }) => (
  <BaseButton _type="text" {...rest}>
    {children}
  </BaseButton>
);

Button.propTypes = BaseButton.propTypes;
Button.defaultProps = BaseButton.defaultProps;

Button.Text = ({ children, ...rest }) => (
  <BaseButton {...rest} _type="text">
    {children}
  </BaseButton>
);

Button.Text.propTypes = BaseButton.propTypes;
Button.Text.defaultProps = BaseButton.defaultProps;

Button.TextIcon = (props) => {
  const { children, icon, iconPosition, size, ...rest } = props;

  const baseProps = { size, ...rest };
  const textIconProps = { icon, iconPosition, size };

  return (
    <BaseButton {...baseProps} _type="text-icon">
      <TextIcon {...textIconProps}>{children}</TextIcon>
    </BaseButton>
  );
};
Button.TextIcon.propTypes = { ...BaseButton.propTypes, ...TextIcon.propTypes };
Button.TextIcon.defaultProps = {
  ...BaseButton.defaultProps,
  ...TextIcon.defaultProps,
};

Button.Icon = (props) => {
  const { children, className, icon, minWidth, size, ...rest } = props;

  const baseProps = { size, ...rest };
  const iconProps = { icon, size };

  return (
    <BaseButton minWidth="unset" {...baseProps} _type="icon">
      <Icon {...iconProps} />
    </BaseButton>
  );
};
Button.Icon.propTypes = { ...BaseButton.propTypes, ...Icon.propTypes };
Button.Icon.defaultProps = { ...BaseButton.defaultProps, ...Icon.defaultProps };

export default Button;
